import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ChartService {

  urlPrefix = '';

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) { }

  getScopePhases(){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/scopePhases?apiKey=${this.userService.apiKey}`;
    return this.http.get(url);
  }

  getObjectsByLibraryGeneral(){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/objectsByLibraryType?apiKey=${this.userService.apiKey}&level=general`;
    return this.http.get(url);
  }

  getObjectsByLibrarySummary(scope?: string | null, phase?: string[] | null){
    let url = `${this.urlPrefix}/api/${this.userService.customer}/charts/objectsByLibraryType?apiKey=${this.userService.apiKey}&level=summary`;
    if(scope) url = url.concat(`&scope=${scope}`);
    if(phase?.length) url = url.concat(`&phase=${phase.join(',')}`);
    return this.http.get(url);
  }

  getObjectsByLibraryDetail(type: string, scope?: string | null, phase?: string[] | null){
    let url = `${this.urlPrefix}/api/${this.userService.customer}/charts/objectsByLibraryType?apiKey=${this.userService.apiKey}&level=detail&type=${type}`;
    if(scope) url = url.concat(`&scope=${scope}`);
    if(phase?.length) url = url.concat(`&phase=${phase.join(',')}`);
    return this.http.get(url);
  }

  getObjectsByLibraryName(name: string | null, scope?: string[] | null, phase?: string[] | null){
    let url = `${this.urlPrefix}/api/${this.userService.customer}/charts/objectsByLibraryName?apiKey=${this.userService.apiKey}&name=${name ? encodeURIComponent(name) : ''}`;
    if(scope) url = url.concat(`&scope=${scope}`);
    if(phase?.length) url = url.concat(`&phase=${phase.join(',')}`);
    return this.http.get(url);
  }
  
  exportLibrariesDetail(scope?: any[] | null, phase?: any[] | null){
    let url = `${this.urlPrefix}/api/${this.userService.customer}/charts/objectsByLibraryNameExport?apiKey=${this.userService.apiKey}`;
    if(scope) url = url.concat(`&scope=${scope.join(',')}`);
    if(phase?.length) url = url.concat(`&phase=${phase.join(',')}`);
    return this.http.get(url, {responseType: 'arraybuffer'});
  }

  getSourceAnalysisChart(scope?: string[] | null, phase?: number[] | null){
    let url = `${this.urlPrefix}/api/${this.userService.customer}/charts/sourceAnalysis?apiKey=${this.userService.apiKey}`;
    if(scope) url = url.concat(`&scope=${scope.join(',')}`);
    if(phase?.length) url = url.concat(`&phase=${phase.join(',')}`);
    return this.http.get(url);
  }

  getCopybookSummary(){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/copybooksSummary?apiKey=${this.userService.apiKey}`;
    return this.http.get(url);
  }

  getCopybookByLibrary(library: string){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/copybooksByLibrary?apiKey=${this.userService.apiKey}&library=${library}`;
    return this.http.get(url);
  }

  getCopybookByFile(library: string, file: string){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/copybooksByFile?apiKey=${this.userService.apiKey}&library=${encodeURIComponent(library)}&file=${file}`;
    return this.http.get(url);
  }

  getLOCChart(scope?: string[] | null, phase?: number[] | null){
    let url = `${this.urlPrefix}/api/${this.userService.customer}/charts/locByObjectType?apiKey=${this.userService.apiKey}`;
    if(scope) url = url.concat(`&scope=${scope.join(',')}`);
    if(phase?.length) url = url.concat(`&phase=${phase.join(',')}`);
    return this.http.get(url);
  }

  getInventorySummary(scope?: string[] | null, phase?: string[] | null){
    let url = `${this.urlPrefix}/api/${this.userService.customer}/charts/inventorySummary?apiKey=${this.userService.apiKey}`;
    if(scope) url = url.concat(`&scope=${scope.join(',')}`);
    if(phase?.length) url = url.concat(`&phase=${phase.join(',')}`);
    return this.http.get(url);
  } 

  getInventotyByType(type: string, scope?: string[] | null, phase?: string[] | null){
    let url = `${this.urlPrefix}/api/${this.userService.customer}/charts/inventoryByType?apiKey=${this.userService.apiKey}&type=${type}`;
    if(scope) url = url.concat(`&scope=${scope.join(',')}`);
    if(phase?.length) url = url.concat(`&phase=${phase.join(',')}`);
    return this.http.get(url);
  }

  getInventoryDetail(type: string, attribute: string, scope?: string[] | null, phase?: string[] | null){
    let url = `${this.urlPrefix}/api/${this.userService.customer}/charts/inventoryDetail?apiKey=${this.userService.apiKey}&type=${type}&attribute=${attribute}`;
    if(scope) url = url.concat(`&scope=${scope.join(',')}`);
    if(phase?.length) url = url.concat(`&phase=${phase.join(',')}`);
    return this.http.get(url);
  }

  getDistributionChart(phase: string){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/distribution?apiKey=${this.userService.apiKey}&phase=${phase}`;
    return this.http.get(url);
  }

  getDistributionDetail(size: string){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/distributionDetail?apiKey=${this.userService.apiKey}&size=${size}`;
    return this.http.get(url);
  }

  getDistributionPhases(){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/distributionPhases?apiKey=${this.userService.apiKey}`;
    return this.http.get(url);
  }

  getSourceSummary(phase?: string[] | null){
    let url = `${this.urlPrefix}/api/${this.userService.customer}/charts/sourceAnalysisSummary?apiKey=${this.userService.apiKey}`;
    if(phase?.length) url = url.concat(`&phase=${phase.join(',')}`);
    
    return this.http.get(url);
  }

  getSourceAnalysisOverview(){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/sourceAnalysisOverview?apiKey=${this.userService.apiKey}`;
    return this.http.get(url);
  }

  getSourceAnalysisOverviewMedium(attribute: string){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/sourceAnalysisOverviewMedium?apiKey=${this.userService.apiKey}&attribute=${attribute}`;
    return this.http.get(url);
  }

  getSourceAnalysisOverviewDetail(attribute: string, srcmatch: string){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/sourceAnalysisOverviewDetail?apiKey=${this.userService.apiKey}&attribute=${attribute}&srcmatch=${encodeURIComponent(srcmatch)}`;
    return this.http.get(url);
  }
  
  getSupportingObjects(){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/supportingObjects?apiKey=${this.userService.apiKey}`;
    return this.http.get(url);
  }

  getSupportingObjectsByType(type: string){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/supportingObjectsByType?apiKey=${this.userService.apiKey}&type=${type}`;
    return this.http.get(url);
  }

  getSupportingObjectsByLibrary(type: string, library: string){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/supportingObjectsByLibrary?apiKey=${this.userService.apiKey}&type=${encodeURIComponent(type)}&library=${encodeURIComponent(library)}`;
    return this.http.get(url);
  }

  getSupportingObjectsDetail(type: string, library: string, attribute: string){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/supportingObjectsDetail?apiKey=${this.userService.apiKey}&type=${encodeURIComponent(type)}&library=${encodeURIComponent(library)}&attribute=${encodeURIComponent(attribute)}`;
    return this.http.get(url);
  }

  getPhaseSummary(){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/phaseSummary?apiKey=${this.userService.apiKey}`;
    return this.http.get(url);
  }

  getAppAreaByPhase(phase: number) {
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/getAppAreaByPhase?apiKey=${this.userService.apiKey}&phase=${phase}`;
    return this.http.get(url);
  }

  getLibraryByPhase(phase: number, apparea: string){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/getLibraryByPhase?apiKey=${this.userService.apiKey}&phase=${phase}&apparea=${apparea}`;
    return this.http.get(url);
  }

  phaseDetailTable(phase: number, apparea: string, library: string){
    const url = `${this.urlPrefix}/api/${this.userService.customer}/charts/phaseDetailTable?apiKey=${this.userService.apiKey}&phase=${phase}&apparea=${apparea}&library=${library}`;
    return this.http.get(url);
  }

  getComplexityChart(phase: null | string[]){
    let url = `${this.urlPrefix}/api/${this.userService.customer}/charts/complexitiesChart?apiKey=${this.userService.apiKey}`;
    if(phase) url = url.concat(`&phase=${phase.join(',')}`);
    return this.http.get(url);
  }
}
